import { DATE_INPUT_MIN } from '@/lib/dates';

/**
 * A labelled date input for the Contracts forms. `max` is today: every date on
 * these forms records something that has already happened, and the API refuses a
 * future one, so the picker stops a fat-fingered year before it gets that far.
 */
export default function DateField({ label, value, max, onChange, help }: {
  label: string;
  value: string;
  max: string;
  onChange: (value: string) => void;
  help?: string;
}) {
  return (
    <label className="ct-field">
      <span>{label}</span>
      <input
        type="date"
        value={value}
        min={DATE_INPUT_MIN}
        max={max}
        onChange={(e) => onChange(e.target.value)}
      />
      {help && <span className="ct-help">{help}</span>}
    </label>
  );
}
